/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCollapseTrianglesHOpenIcon16Solid = forwardRef('ArrowCollapseTrianglesHOpenIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "m10.28 3.78 3.336 3.336a1.25 1.25 0 0 1 0 1.768L10.28 12.22A.75.75 0 0 1 9 11.69V4.31a.75.75 0 0 1 1.28-.53Z" }),
        React.createElement("path", { d: "M2.384 7.116 5.719 3.78A.75.75 0 0 1 7 4.31v7.38a.75.75 0 0 1-1.28.53L2.384 8.884a1.25 1.25 0 0 1 0-1.768Z" })));
});
